import {reportJobViewLinkClickEvent, reportJobApplyEvent} from "../utils/analytics";
import $jsAPI from "../front_end_api";
import {addSkipRegWallParamToHrefAttrIfNeeded} from "../utils/regwallUtil";

let jobsList = window.jobsList ? window.jobsList : [];

function getJobById(jobId)
{
  return jobsList.find(jobItem => jobItem.id == jobId);
}

const initPage = () => {
  const jobListingItems = $(".job-listings-item");
  if (!jobListingItems.length) {
    return;
  }

  const dynamicPageTabs = $('a[data-toggle="tab"]');
  dynamicPageTabs.on('shown.bs.tab', function (e) {
    const eventTarget = $(e.target);

    dynamicPageTabs.parent('li').removeClass('active');
    eventTarget.parent('li').addClass('active');

    let jobsListingPagination = $(".jobs-listing-pagination");
    if (eventTarget.attr("href") === '#about') {
      jobsListingPagination.addClass('d-none')
    } else {
      jobsListingPagination.removeClass('d-none')
    }
  });

  jobListingItems.each((i, elem) => {
    const jobItem = window.jobsList.find(job => job.id === +elem.dataset.jobid);
    if (jobItem && !$jsAPI.callFunction('shouldRegistrationWallBeDisplayed', [jobItem], true)) {
      const applyBtn = $(elem).find('.apply-button:not([data-opens-job-details])');

      if (applyBtn) {
        addSkipRegWallParamToHrefAttrIfNeeded(applyBtn, jobItem);
      }
    }

    elem.addEventListener("click", e => {
      const target = e.target;

      if(target.closest('a')) {
        return;
      }
      const link = elem.querySelector('.job-details-link');
      if(link) {
        link.click();
      }
    }, {capture: true})
  })


  $(".job-listings-item .apply-button").click(function(){
    const parentCard = $(this).closest('.job-listings-item');
    const jobId = parentCard.data('jobid');

    const job = getJobById(jobId);
    if (job) {
      if (this.hasAttribute('data-opens-job-details')) {
        reportJobViewLinkClickEvent(job);
        return;
      }

      $jsAPI.fireEvent('job:apply_button_clicked', job, 'job_listing')
      reportJobApplyEvent(job);
    }
  });

  $(".job-listings-item .job-details-link").click(function(){
    const parentCard = $(this).closest('.job-listings-item');
    const jobId = parentCard.data('jobid');

    const job = getJobById(jobId);
    if (job) {
      reportJobViewLinkClickEvent(job);
    }
  });
};

$(initPage);
